import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import React, { useRef, useState } from 'react';
import { getContext } from 'react-recompose';
import PropTypes from 'prop-types';
import classname from 'classnames';
import { colors, positions, sizes } from "../../../enums";
import { whitelistStyles } from "../hoc";
import AdaptiveTooltipContent from "./adaptive-tooltip-content";
/**
 * Generates the wrapper around the child component and creates the tooltip element.
 * */

export var AdaptiveTooltip = function AdaptiveTooltip(_ref) {
  var children = _ref.children,
      tooltip = _ref.tooltip,
      position = _ref.position,
      isInverted = _ref.isInverted,
      isCompact = _ref.isCompact,
      isInline = _ref.isInline,
      delay = _ref.delay,
      size = _ref.size,
      color = _ref.color;
  var timeoutShowTooltip = useRef(null);
  var childrenRef = useRef(null);

  var _useState = useState(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var handleMouseEnter = function handleMouseEnter() {
    if (visible || !childrenRef.current || !tooltip) return;
    timeoutShowTooltip.current = _setTimeout(function () {
      setVisible(true);
    }, delay);
  };

  var handleMouseLeave = function handleMouseLeave() {
    if (timeoutShowTooltip.current) {
      clearTimeout(timeoutShowTooltip.current);
    }

    setVisible(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classname('ck-adaptive-tooltip__children-wrapper', {
      'ck-adaptive-tooltip__children-wrapper--inline': isInline
    }),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: childrenRef
  }, children), /*#__PURE__*/React.createElement(AdaptiveTooltipContent, {
    hoveredElementRef: childrenRef.current,
    isInverted: isInverted,
    isCompact: isCompact,
    position: position,
    visible: visible,
    color: color,
    size: size
  }, tooltip));
};
AdaptiveTooltip.defaultProps = {
  tooltip: '',
  position: positions.TOP,
  size: sizes.MEDIUM,
  color: colors.BASE,
  isInverted: false,
  isCompact: false,
  isInline: true,
  delay: 300
};
AdaptiveTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  position: PropTypes.oneOf(positions.ALL),
  isInverted: PropTypes.bool,
  size: PropTypes.oneOf([sizes.SMALL, sizes.MEDIUM, sizes.LARGE]),
  color: PropTypes.oneOf([colors.BASE, colors.ERROR]),
  delay: PropTypes.number,
  isCompact: PropTypes.bool,
  isInline: PropTypes.bool
};
export default whitelistStyles()(getContext({
  isInverted: PropTypes.bool
})(AdaptiveTooltip));
//# sourceMappingURL=adaptive-tooltip.js.map